import { ConfigPatch } from 'src/config/types';

export default (): ConfigPatch => ({
    salesChannelId: '379ce4e7-cd4f-40d6-a714-44bf9a2e3ff6',
    countryCodes: ['FI'],
    locale: 'fi-FI',
});
